/**
 * Util functions and classes
 */

var Geometry = require("./basicGeometry.js");

Geometry.any = function(array, f) {
    for(var i = 0; i<array.length; i++)
        if(f(array[i])) return true;
    return false;
};

Geometry.all = function(array, f) {
    for(var i = 0; i<array.length; i++)
        if(!f(array[i])) return false;
    return true;
};

Geometry.inherit = function(child, parent) {
    child.prototype = Object.create(parent.prototype);
    child.prototype.constructor = child;
};

Geometry.Transform = function(vec, angle, flip) {
    this.translation = vec || new Geometry.Coord(0,0);
    this.angle = angle || 0;
    this.flip = flip || false;
    //TODO: add scaling etc.
};

/**
 * Checks whether or not 3 points are collinear
 * @param p1
 * @param p2
 * @param p3
 * @param precision
 * @return boolean true if the points are collinear, else false
 */
Geometry.collinear = function(p1,p2,p3,precision){
    if(!precision){
        precision = 1e-7;
    }
    //area of triangle p1,p2,p3
    var res = Math.abs(p1.x*(p2.y-p3.y)+p2.x*(p3.y-p1.y)+p3.x*(p1.y-p2.y))<precision;
    return res;
};

/**
 * Checks if the point p2 is left or right of the line through p1 and p3
 * @param p1
 * @param p2
 * @param p3
 */
Geometry.pointLineSide = function(p1,p2,p3) {
    var res = (p3.x-p1.x)*(p2.y-p1.y)-(p3.y-p1.y)*(p2.x-p1.x);
    if(res>0){
        return 1;
    } else if(res<0){
        return -1;
    } else {
        return 0;
    }
};

Geometry.counterClockwise = function(a,b,c) {
    return (b.y-a.y)*(c.x-a.x) < (c.y-a.y)*(b.x-a.x);
};

Geometry.clockwise = function(a,b,c) {
    return (b.y-a.y)*(c.x-a.x) > (c.y-a.y)*(b.x-a.x);
};

Geometry.areaTriangle = function(p1, p2, p3) {
    return Math.abs((p1.x * (p2.y - p3.y) + p2.x * (p3.y - p1.y) + p3.x * (p1.y - p2.y)) / 2);
};

